import React from 'react'
import {Route} from 'react-router'
import RedirectWithParams from '../../core/components/redirect-with-params/RedirectWithParams'
import VisibleTopic from './containers/VisibleTopic'

let topicRoute = [
  <Route exact key={'/t/:topicIdOrSlug'} path='/t/:topicIdOrSlug' component={VisibleTopic} />,
  <RedirectWithParams key={'/map/:topicIdOrSlug'} from='/map/:topicIdOrSlug' to='/t/:topicIdOrSlug' />
]
export default topicRoute



// WEBPACK FOOTER //
// ./src/domains/topic/index.js